// www.ahmetmusaok.com.tr - Limoya Reels
(() => {
  'use strict';

  const VIEW_URL = '/collections/reels?view=reels';
  const WISHLIST_KEY = 'm-wishlist-products';
  const RATIO = { 'Kış': 0.10, 'Sezonsuz': 0.60, 'Yaz': 0.30 };
  const AUTO_BUTTON = true;
  const SOUND_OFF_ICON = 'https://cdn.shopify.com/s/files/1/0662/9769/2322/files/speaker-off.svg?v=1765833579';
  const SOUND_ON_ICON  = 'https://cdn.shopify.com/s/files/1/0662/9769/2322/files/speaker-on.svg?v=1765833579';
  const PLAY_ICON      = 'https://cdn.shopify.com/s/files/1/0662/9769/2322/files/play-icon.svg?v=1765889362';


  // Virtual buffer
  const BUFFER_BEFORE = 1;
  const BUFFER_AFTER  = 1;

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  const safeJson = (str, fallback) => {
    try { return JSON.parse(str); } catch { return fallback; }
  };

  const toast = (msg) => {
    const el = $('#lrToast');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-open');
    setTimeout(() => el.classList.remove('is-open'), 1400);
  };

  const normSeason = (s) => {
    s = (s || '').toString().trim().toLowerCase();
    if (s.includes('kış') || s.includes('kis')) return 'Kış';
    if (s.includes('yaz')) return 'Yaz';
    if (s.includes('sezonsuz')) return 'Sezonsuz';
    return 'Sezonsuz';
  };

  const shuffle = (arr) => {
    const a = arr.slice();
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  };

  function weightedMerge(groups, ratio) {
    const keys = ['Kış', 'Sezonsuz', 'Yaz'];
    const total = keys.reduce((a, k) => a + (groups[k]?.length || 0), 0);
    if (!total) return [];

    const target = {};
    keys.forEach(k => target[k] = Math.round(total * (ratio[k] || 0)));

    let sumT = keys.reduce((a, k) => a + target[k], 0);
    while (sumT < total) { target['Kış']++; sumT++; }
    while (sumT > total) { target['Yaz'] = Math.max(0, target['Yaz'] - 1); sumT--; }

    const buckets = {
      'Kış': (groups['Kış'] || []).slice(),
      'Sezonsuz': (groups['Sezonsuz'] || []).slice(),
      'Yaz': (groups['Yaz'] || []).slice()
    };

    const out = [];
    let safety = 0;

    while (out.length < total && safety++ < total * 30) {
      for (const k of keys) {
        if (out.length >= total) break;

        if (target[k] > 0 && buckets[k].length) {
          out.push(buckets[k].shift());
          target[k]--;
        } else if (target[k] > 0 && !buckets[k].length) {
          const donor = keys.find(x => buckets[x].length);
          if (donor) {
            out.push(buckets[donor].shift());
            target[k]--;
          }
        }
      }

      const left = keys.some(k => buckets[k].length);
      const targetLeft = keys.some(k => target[k] > 0);
      if (left && !targetLeft) {
        keys.forEach(k => { while (buckets[k].length) out.push(buckets[k].shift()); });
      }
    }

    return out.slice(0, total);
  }

  /* ===== Wishlist (Minimog) ===== */
  function getWishlist() {
    const raw = localStorage.getItem(WISHLIST_KEY);
    const arr = safeJson(raw || '[]', []);
    return Array.isArray(arr) ? arr : [];
  }
  function setWishlist(arr) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(arr));
    window.dispatchEvent(new Event('storage'));
  }
  function isInWishlist(handle) {
    return getWishlist().includes(handle);
  }
  function toggleWishlist(handle) {
    let arr = getWishlist();
    const exists = arr.includes(handle);
    if (exists) {
      arr = arr.filter(x => x !== handle);
      setWishlist(arr);
      return false;
    } else {
      arr.push(handle);
      setWishlist(arr);
      return true;
    }
  }

  /* ===== State ===== */
  const state = {
    page: 1,
    hasMore: true,
    isLoading: false,
    metaAll: [],
    metaFiltered: [],
    season: 'ALL',

    feedEl: null,

    soundOn: false,
    activeIndex: 0,

    slideCache: new Map(),

    // spacer elements (scroll yüksekliği için)
    topSpacer: null,
    bottomSpacer: null,

    // slide height cache
    slideHeight: 0,

    // şu an gerçekten oynayan video ref
    currentVideo: null,

    // scroll ile index hesaplama
    _onScroll: null,

    isScrolling: false,
    _scrollIdleTimer: null,
  };

  /* ===== UI ===== */
  function ensureModalUI() {
    if ($('#lrModal')) return;

    const modal = document.createElement('div');
    modal.className = 'lr-modal';
    modal.id = 'lrModal';
    modal.innerHTML = `
      <div class="lr-shell">
        <div class="lr-topbar">
          <div class="lr-chips" id="lrChips">
            <button class="lr-chip is-active" data-season="ALL">Tümü</button>
            <button class="lr-chip" data-season="Kış">Kış</button>
            <button class="lr-chip" data-season="Sezonsuz">Sezonsuz</button>
            <button class="lr-chip" data-season="Yaz">Yaz</button>
          </div>
          <button class="lr-close" id="lrClose" aria-label="Kapat">✕</button>
        </div>
        <div class="lr-feed" id="lrFeed"></div>
      </div>
    `;
    document.body.appendChild(modal);

    const sheetBackdrop = document.createElement('div');
    sheetBackdrop.className = 'lr-sheet-backdrop';
    sheetBackdrop.id = 'lrSheetBackdrop';
    document.body.appendChild(sheetBackdrop);

    const sheet = document.createElement('div');
    sheet.className = 'lr-sheet';
    sheet.id = 'lrSheet';
    sheet.innerHTML = `
      <div class="lr-sheet-panel">
        <div class="lr-sheet-head">
          <div>
            <div class="lr-sheet-title" id="lrSheetTitle">Numara Seç</div>
            <div class="lr-sheet-sub" id="lrSheetSub"></div>
          </div>
          <button class="lr-sheet-close" id="lrSheetClose" aria-label="Kapat">✕</button>
        </div>
        <div class="lr-sizes" id="lrSizes"></div>
      </div>
    `;
    document.body.appendChild(sheet);

    const toastEl = document.createElement('div');
    toastEl.className = 'lr-toast';
    toastEl.id = 'lrToast';
    document.body.appendChild(toastEl);

    $('#lrClose').addEventListener('click', closeModal);
    sheetBackdrop.addEventListener('click', closeSheet);
    $('#lrSheetClose').addEventListener('click', closeSheet);

    $('#lrChips').addEventListener('click', (e) => {
      const btn = e.target.closest('.lr-chip');
      if (!btn) return;
      $$('.lr-chip').forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      state.season = btn.dataset.season;
      applyFilterAndRender(true);
    });

    modal.addEventListener('click', (e) => {
      if (e.target === modal) closeModal();
    });

    state.feedEl = $('#lrFeed');

    // spacerları oluştur
    state.topSpacer = document.createElement('div');
    state.bottomSpacer = document.createElement('div');
    state.topSpacer.id = 'lrTopSpacer';
    state.bottomSpacer.id = 'lrBottomSpacer';
    state.topSpacer.style.height = '0px';
    state.bottomSpacer.style.height = '0px';
    state.feedEl.appendChild(state.topSpacer);
    state.feedEl.appendChild(state.bottomSpacer);
  }

  function ensureButton() {
    if (!AUTO_BUTTON) return;

    let btn = $('#limoya-reels-btn');
    if (!btn) {
      btn = document.createElement('div');
      btn.id = 'limoya-reels-btn';
      btn.innerHTML = `
      <div class="lr-inner">
        <div class="lr-label">LİMOYA<br>REELS</div>
      </div>
    `;
      document.body.appendChild(btn);
    }
    btn.onclick = openModal;
  }

  /* ===== Load view -> meta ===== */
  function extractVideoSrc(node) {
    const v = node.querySelector('video');
    if (!v) return '';
    const direct = v.getAttribute('src');
    if (direct) return direct;
    const srcEl = v.querySelector('source[src]');
    if (srcEl) return srcEl.getAttribute('src') || '';
    return '';
  }

  async function fetchViewMeta() {
    let page = 1;
    let allNodes = [];

    while (true) {
      const res = await fetch(`${VIEW_URL}&page=${page}`, { credentials: 'same-origin' });
      const html = await res.text();

      const doc = new DOMParser().parseFromString(html, 'text/html');
      const nodes = Array.from(doc.querySelectorAll('[data-reel]'));

      if (!nodes.length) break;

      allNodes = allNodes.concat(nodes);

      // Shopify genelde 20 ürün döner → azsa bitmiştir
      if (nodes.length < 20) break;

      page++;
    }

    const doc = new DOMParser().parseFromString(html, 'text/html');

    const raw = allNodes;
    const groups = { 'Kış': [], 'Sezonsuz': [], 'Yaz': [] };

  const seen = new Set();

  raw.forEach(node => {
    const season = normSeason(node.getAttribute('data-season'));
    const renkmeta = (node.getAttribute('data-renkmeta') || '').trim();

    // renkmeta yoksa fallback
    const key = renkmeta || node.getAttribute('data-handle');

    if (seen.has(key)) return;
    seen.add(key);

    const meta = {
      season,
      handle: node.getAttribute('data-handle') || '',
      url: node.getAttribute('data-url') || '#',
      posterSrc: extractPosterSrc(node),
      title: node.getAttribute('data-title') || '',
      price: node.getAttribute('data-price') || '',
      variantsRaw: node.getAttribute('data-variants') || '[]',
      videoSrc: extractVideoSrc(node),
      renkmeta,
    };

    if (!meta.videoSrc) return;

    groups[season].push(meta);
  });

    groups['Kış'] = shuffle(groups['Kış']);
    groups['Sezonsuz'] = shuffle(groups['Sezonsuz']);
    groups['Yaz'] = shuffle(groups['Yaz']);

    const merged = weightedMerge(groups, RATIO);
    return shuffle(merged);
  }

  function escapeHtml(s) {
    return String(s || '').replace(/[&<>"']/g, (m) => ({
      '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'
    }[m]));
  }

  async function loadMoreReels() {
  if (!state.hasMore || state.isLoading) return;

  state.isLoading = true;

  const res = await fetch(`${VIEW_URL}&page=${state.page}`, { credentials: 'same-origin' });
  const html = await res.text();

  const doc = new DOMParser().parseFromString(html, 'text/html');
  const nodes = Array.from(doc.querySelectorAll('[data-reel]'));

  if (!nodes.length) {
    state.hasMore = false;
    state.isLoading = false;
    return;
  }

  const seen = new Set(state.metaAll.map(m => m.renkmeta || m.handle));
  const newItems = [];

  nodes.forEach(node => {
    const season = normSeason(node.getAttribute('data-season'));
    const renkmeta = (node.getAttribute('data-renkmeta') || '').trim();
    const key = renkmeta || node.getAttribute('data-handle');

    if (seen.has(key)) return;
    seen.add(key);

    const meta = {
      season,
      handle: node.getAttribute('data-handle') || '',
      url: node.getAttribute('data-url') || '#',
      posterSrc: extractPosterSrc(node),
      title: node.getAttribute('data-title') || '',
      price: node.getAttribute('data-price') || '',
      variantsRaw: node.getAttribute('data-variants') || '[]',
      videoSrc: extractVideoSrc(node),
      renkmeta,
    };

    if (!meta.videoSrc) return;

    newItems.push(meta);
  });

  if (newItems.length === 0) {
  state.hasMore = false;
  state.isLoading = false;
  return;
}

  const shuffled = shuffle(newItems);

  state.metaAll.push(...shuffled);
  state.page++;
  state.isLoading = false;
}


  function extractPosterSrc(node) {
    const img = node.querySelector('img');
    if (!img) return '';

    return (
      img.getAttribute('src') ||
      img.getAttribute('data-src') ||
      img.getAttribute('data-original') ||
      img.getAttribute('data-lazy') ||
      ''
    );
  }


  /* ===== Video helpers ===== */
  function setVideoSound(video) {
    if (!video) return;
    video.muted = !state.soundOn;
    video.volume = 1;
  }

    function preloadIcons() {
    [SOUND_OFF_ICON, SOUND_ON_ICON, PLAY_ICON].forEach((u) => {
      const img = new Image();
      img.decoding = 'async';
      img.loading = 'eager';
      img.src = u;
    });
  }

function ensureSrc(video) {
  if (!video) return false;

  // ÖNEMLİ: property değil attribute kontrolü
  const attr = video.getAttribute('src');
  if (attr && attr.trim()) return true;

  const src = video.dataset.src || '';
  if (!src) return false;

  video.setAttribute('src', src); // asıl doğru olan
  // bazı browserlar için garanti
  try { video.src = src; } catch {}

  return true;
}

  function releaseSrc(video) {
    if (!video) return;

    try { video.pause(); } catch {}
    try { video.muted = true; } catch {}

    // SADECE attribute kaldır, property'e dokunma
    try { video.removeAttribute('src'); } catch {}
    try { video.removeAttribute('currentSrc'); } catch {} // zararsız

    // source varsa temizle
    try {
      const s = video.querySelector('source');
      if (s) s.removeAttribute('src');
    } catch {}

    // buffer boşalt
    try { video.load(); } catch {}

    try {
      const slide = video.closest('.lr-item');
      const poster = slide ? slide.querySelector('.lr-poster') : null;
      if (poster) poster.classList.remove('is-hide');
    } catch {}

  }



  function hardStop(video) {
    if (!video) return;
    try { video.pause(); } catch {}
    // ses karışmasını bitirmek için
    try { video.muted = true; } catch {}
    try { video.currentTime = video.currentTime; } catch {}
  }

  function setPlayOverlay(slide, show) {
    if (!slide) return;
    const b = slide.querySelector('.lr-play');
    if (!b) return;
    b.classList.toggle('is-show', !!show);
  }

function playOnly(video, slide) {
  state.currentVideo = video;

  // autoplay policy: önce muted
  video.muted = true;
  video.volume = 1;

  //  aktif video öncelik
  try { video.preload = 'auto'; } catch {}
  try { video.setAttribute('fetchpriority', 'high'); } catch {}

  //  iOS/Safari bazı durumlarda play() reject etmeden paused bırakıyor
  // Bu yüzden her durumda kısa bir kontrol koyuyoruz.
  const showIfStillPaused = () => {
    if (state.currentVideo !== video) return;
    if (video.paused) setPlayOverlay(slide, true);
  };

  // İlk etapta gizle (eğer oynarsa zaten görünmeyecek)
  setPlayOverlay(slide, false);

// Src yoksa şimdi bağla (aktif video her zaman öncelikli)
if (!ensureSrc(video)) {
  setPlayOverlay(slide, true);
  return;
}

  // yüklemeyi tetikle (özellikle preload değişince işe yarar)
  try { video.load(); } catch {}

  let playPromise = null;
  try {
    playPromise = video.play();
  } catch {}

  // oynarsa overlay kapanır
  video.addEventListener('playing', () => setPlayOverlay(slide, false), { once: true });

  // reject olursa overlay göster
  if (playPromise && typeof playPromise.catch === 'function') {
    playPromise.catch(() => setPlayOverlay(slide, true));
  }

  //  EN KRİTİK: reject olmasa bile 450ms sonra paused ise overlay göster
  setTimeout(showIfStillPaused, 450);

  //  veri geldiğinde de kontrol (hızlı kaydırmada çok işe yarar)
  video.addEventListener('loadedmetadata', showIfStillPaused, { once: true });
  video.addEventListener('loadeddata', showIfStillPaused, { once: true });
  video.addEventListener('canplay',    showIfStillPaused, { once: true });

  // ses açık istendiyse: policy izin verirse unmute dene
  if (state.soundOn) {
    video.addEventListener('playing', () => {
      if (state.currentVideo !== video) return;
      try { video.muted = false; } catch {}
    }, { once: true });
  }
}


  function syncSoundIcons() {
    // buffer içindeki tüm sound ikonlarını state'e göre güncelle
    state.slideCache.forEach(slide => {
      const btn = slide.querySelector('[data-role="sound"]');
      if (btn) {
        const img = btn.querySelector('img.lr-sound-ico');
        if (img) img.src = state.soundOn ? SOUND_ON_ICON : SOUND_OFF_ICON;
        else btn.innerHTML = `<img class="lr-sound-ico" alt="Sound" src="${state.soundOn ? SOUND_ON_ICON : SOUND_OFF_ICON}">`;
      }
      const v = slide.querySelector('video');
      if (v) setVideoSound(v);
    });
  }

  /* ===== Virtual Slide Build ===== */
  function buildSlide(meta, index) {
    const slide = document.createElement('div');
    slide.className = 'lr-item';
    slide.dataset.index = String(index);

    // poster (video yüklenene kadar görünen görsel)
    const poster = document.createElement('img');
    poster.className = 'lr-poster';
    poster.alt = meta.title || '';
    poster.decoding = 'async';
    poster.loading = (index === state.activeIndex) ? 'eager' : 'lazy';
    poster.src = meta.posterSrc || '';
    slide.appendChild(poster);

    const v = document.createElement('video');
    v.className = 'lr-video';
    v.playsInline = true;
    v.loop = true;
    v.autoplay = false;
    v.preload = 'none'; // Hiçbirşey indirmiyor preload için yeni fonksiyon tunePreloadPriorities
    v.setAttribute('playsinline', '');
    v.dataset.src = meta.videoSrc;
    //v.src = meta.videoSrc;
    // her slide state'e göre başlasın
    setVideoSound(v);
    slide.appendChild(v);
    //  video duraklarsa (özellikle iOS hızlı kaydırmada) play butonu gözüksün
    v.addEventListener('pause', () => {
      if (Number(slide.dataset.index) === state.activeIndex) setPlayOverlay(slide, true);
    });
    v.addEventListener('playing', () => setPlayOverlay(slide, false));

    v.addEventListener('playing', () => {
      if (state.currentVideo !== v) hardStop(v);
    });

    const hidePoster = () => poster.classList.add('is-hide');
    const showPoster = () => poster.classList.remove('is-hide');

    v.addEventListener('loadeddata', hidePoster, { once: true });
    v.addEventListener('playing', hidePoster);
    v.addEventListener('waiting', showPoster);  // buffer beklerse geri gelsin
    v.addEventListener('stalled', showPoster);

    const tap = document.createElement('div');
    const playOverlay = document.createElement('button');
    playOverlay.type = 'button';
    playOverlay.className = 'lr-play';
    playOverlay.setAttribute('aria-label', 'Oynat');
    playOverlay.innerHTML = `<img class="lr-play-ico" alt="Play" src="${PLAY_ICON}">`;
    slide.appendChild(playOverlay);

    // Play butonuna basınca oynat
    playOverlay.addEventListener('click', (e) => {
      e.stopPropagation();

      // kullanıcı dokundu -> scroll kilitlerini bırak
      state.isScrolling = false;
      if (state._scrollIdleTimer) {
        clearTimeout(state._scrollIdleTimer);
        state._scrollIdleTimer = null;
      }

      // bu slide'ı aktif yap
      const idx = Number(slide.dataset.index) || 0;
      state.activeIndex = idx;

      // src/öncelikleri düzelt ve oynat
      tunePreloadPriorities(idx);
      playOnly(v, slide);
    });


    tap.className = 'lr-tap';
    slide.appendChild(tap);

    const actions = document.createElement('div');
    actions.className = 'lr-actions';

    const soundBtn = document.createElement('button');
    soundBtn.type = 'button';
    soundBtn.className = 'lr-iconbtn';
    soundBtn.title = 'Ses';
    soundBtn.dataset.role = 'sound';
    soundBtn.innerHTML = `<img class="lr-sound-ico" alt="Sound" src="${state.soundOn ? SOUND_ON_ICON : SOUND_OFF_ICON}">`;

    const favBtn = document.createElement('button');
    favBtn.type = 'button';
    favBtn.className = 'lr-iconbtn';
    favBtn.title = 'Favori';
    favBtn.textContent = isInWishlist(meta.handle) ? '♥' : '♡';

    actions.appendChild(soundBtn);
    actions.appendChild(favBtn);
    slide.appendChild(actions);

    const bottom = document.createElement('div');
    bottom.className = 'lr-bottom';
    bottom.innerHTML = `
      <div class="lr-card">
        <div class="lr-title">${escapeHtml(meta.title)}</div>
        <div class="lr-sub">
          <span>${meta.season}</span>
          <span class="lr-price">${escapeHtml(meta.price)}</span>
        </div>
        <div class="lr-cta">
          <button class="lr-btn" data-act="detail" type="button">Detay</button>
          <button class="lr-btn primary" data-act="cart" type="button">Sepete Ekle</button>
        </div>
      </div>
    `;
    slide.appendChild(bottom);

    tap.addEventListener('click', () => {
      if (!v.paused) return;

      state.isScrolling = false;
      if (state._scrollIdleTimer) {
        clearTimeout(state._scrollIdleTimer);
        state._scrollIdleTimer = null;
      }

      const idx = Number(slide.dataset.index) || 0;
      state.activeIndex = idx;

      tunePreloadPriorities(idx);
      playOnly(v, slide);
    });

    soundBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      state.soundOn = !state.soundOn;
      syncSoundIcons();
      toast(state.soundOn ? 'Ses Açık' : 'Sessiz');
      // aktif video varsa anında uygula
      if (state.currentVideo) setVideoSound(state.currentVideo);
    });

    favBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      const added = toggleWishlist(meta.handle);
      favBtn.textContent = added ? '♥' : '♡';
      toast(added ? 'Favorilere eklendi' : 'Favorilerden çıkarıldı');
    });

    bottom.querySelector('[data-act="detail"]').addEventListener('click', (e) => {
      e.stopPropagation();
      window.location.href = meta.url;
    });

    bottom.querySelector('[data-act="cart"]').addEventListener('click', (e) => {
      e.stopPropagation();
      openSheet(meta);
    });

    return slide;
  }

  function getFilteredMeta() {
    if (state.season === 'ALL') return state.metaAll.slice();
    return state.metaAll.filter(m => m.season === state.season);
  }

  /* ===== Virtual with Spacers ===== */
  function setSpacers(index) {
    const total = state.metaFiltered.length;
    const h = state.slideHeight || window.innerHeight;

    const start = Math.max(0, index - BUFFER_BEFORE);
    const end   = Math.min(total - 1, index + BUFFER_AFTER);

    const topH = start * h;
    const bottomH = Math.max(0, (total - end - 1) * h);

    state.topSpacer.style.height = `${topH}px`;
    state.bottomSpacer.style.height = `${bottomH}px`;
  }

  function clearFeedHard() {
    // tüm videoları sustur
    if (state.feedEl) state.feedEl.querySelectorAll('video').forEach(v => releaseSrc(v));

    // cache temizle
    state.slideCache.clear();
    state.currentVideo = null;

    // feed içini spacerlar hariç temizle
    if (state.feedEl) {
      state.feedEl.innerHTML = '';
      state.feedEl.appendChild(state.topSpacer);
      state.feedEl.appendChild(state.bottomSpacer);
      state.topSpacer.style.height = '0px';
      state.bottomSpacer.style.height = '0px';
    }
  }

  function tunePreloadPriorities(activeIndex) {
    state.slideCache.forEach((slide, i) => {
      const v = slide.querySelector('video');
      if (!v) return;

      const dist = Math.abs(i - activeIndex);

      // Scroll akarken: hiçbir şeye dokunma, kesinlikle src bağlama
      if (state.isScrolling) {
        if (dist !== 0) releaseSrc(v); // aktif olmayanları boşalt
        return;
      }

      if (dist === 0) {
        // SADECE AKTİF video gerçek src alır ve yüklenir
        ensureSrc(v);
        try { v.preload = 'auto'; } catch {}
        try { v.setAttribute('fetchpriority', 'high'); } catch {}
        try { v.load(); } catch {}
        return;
      }
/*
      // İsteğe bağlı: sadece 1 sonraki videoya metadata (çok agresif istemiyorsan kapat)
      if (dist === 1) {
        // NOT: src bağlamak bile bazı tarayıcılarda download başlatabilir.
        // Eğer "metadata bile büyük çekiyor" diyorsan bu bloğu komple kapat.
        ensureSrc(v);
        try { v.preload = 'metadata'; } catch {}
        try { v.setAttribute('fetchpriority', 'low'); } catch {}
        try { v.load(); } catch {}
        return;
      }
*/
      // Uzak: tamamen bırak
      releaseSrc(v);
    });
  }




  function renderBufferAround(index, keepScroll) {
    const feed = state.feedEl;
    const list = state.metaFiltered;
    if (!feed) return;

    const total = list.length;
    if (!total) { clearFeedHard(); return; }

    index = Math.max(0, Math.min(index, total - 1));
    state.activeIndex = index;

    const start = Math.max(0, index - BUFFER_BEFORE);
    const end   = Math.min(total - 1, index + BUFFER_AFTER);

    // scroll konumunu korumak için (spacer değişirken)
    const prevScroll = keepScroll ? feed.scrollTop : null;

    setSpacers(index);

    // Cache dışındakileri kaldır
    for (const [i, el] of state.slideCache.entries()) {
      if (i < start || i > end) {
        const v = el.querySelector('video');
          if (v) releaseSrc(v);   // <<< hardStop yerine
          el.remove();
        state.slideCache.delete(i);
      }
    }

    // Eksikleri oluştur
    for (let i = start; i <= end; i++) {
      if (!state.slideCache.has(i)) {
        const slide = buildSlide(list[i], i);
        state.slideCache.set(i, slide);
      }
    }

    // DOM sırasını doğru kur: topSpacer, [start..end], bottomSpacer
    // Önce mevcut slaytları kaldır (spacerlar kalsın)
    feed.querySelectorAll('.lr-item').forEach(n => n.remove());

    const frag = document.createDocumentFragment();
    for (let i = start; i <= end; i++) frag.appendChild(state.slideCache.get(i));
    feed.insertBefore(frag, state.bottomSpacer);


    // scroll’u koru veya ilgili index'e hizala
    if (keepScroll && prevScroll != null) {
      feed.scrollTop = prevScroll;
    } else {
      // ilgili slide hizası: index * height
      const h = state.slideHeight || window.innerHeight;
      feed.scrollTop = index * h;
    }

    // Sadece aktif videoyu oynat
    const activeSlide = state.slideCache.get(index);
    const activeVideo = activeSlide ? activeSlide.querySelector('video') : null;
    state.slideCache.forEach((slide, keyIdx) => {
      const v = slide.querySelector('video');
      if (!v) return;
      if (v !== activeVideo) releaseSrc(v);
    });

  // Scroll akarken video oynatma / yükleme yok
  if (!state.isScrolling) {
    if (activeVideo) ensureSrc(activeVideo); 
    tunePreloadPriorities(index);
    if (activeVideo) playOnly(activeVideo, activeSlide);
  } else {
    // scrolling: sadece diğerlerini sustur (garanti)
    if (state.feedEl) {
      state.feedEl.querySelectorAll('video').forEach(v => {
        if (v !== activeVideo) hardStop(v);
      });
    }
  }

  // ikonları state'e göre senkronla (scroll durunca)
  if (!state.isScrolling) syncSoundIcons();
}

function setupScrollIndexDriver() {
  const feed = state.feedEl;
  if (!feed) return;

  // önceki listener varsa kaldır
  if (state._onScroll) {
    feed.removeEventListener('scroll', state._onScroll);
    state._onScroll = null;
  }

  // timer varsa temizle
  if (state._scrollIdleTimer) {
    clearTimeout(state._scrollIdleTimer);
    state._scrollIdleTimer = null;
  }

  // scroll biterken kilitlenecek son index
  state._pendingIndex = state.activeIndex;

  const calcIndex = () => {
    const h = state.slideHeight || window.innerHeight;
    if (!h) return state.activeIndex;

    const maxIdx = Math.max(0, state.metaFiltered.length - 1);
    const raw = Math.floor((feed.scrollTop + (h * 0.5)) / h);
    const idx = Math.max(0, Math.min(raw, maxIdx));
    return idx;
  };

  state._onScroll = () => {
    // desktop snap lock aktifken (wheel/drag) burası karışmasın
    if (state._desktopLockRef && state._desktopLockRef()) return;

    state.isScrolling = true;

    const idx = calcIndex();
    if (Number.isFinite(idx)) {
      state._pendingIndex = idx;

      // scroll sırasında sadece buffer/DOM güncelle (renderBufferAround içindeki guard sayesinde video yüklemez)
      if (idx !== state.activeIndex) {
        renderBufferAround(idx, true);
      }
    }

    // idle timer reset
    if (state._scrollIdleTimer) clearTimeout(state._scrollIdleTimer);
    state._scrollIdleTimer = setTimeout(() => {
      state.isScrolling = false;

      // scroll durdu: en son index'e kilitlen, artık renderBufferAround video/preload işini kendi içinde yapar
      const finalIdx = state._pendingIndex ?? state.activeIndex;
      renderBufferAround(finalIdx, true);
    }, 180);

        // sona yaklaştıysa yeni veri çek
    if (state.metaFiltered.length - state.activeIndex < 5) {
      loadMoreReels().then(() => {
        state.metaFiltered = getFilteredMeta();

        // 👇 BU ŞART
        renderBufferAround(state.activeIndex, true);
      });
    }
  };

  feed.addEventListener('scroll', state._onScroll, { passive: true });
}


  function setupDesktopSnapControls() {
    const feed = state.feedEl;
    const modal = document.getElementById('lrModal');
    if (!feed || !modal) return;

    const isDesktop = window.matchMedia('(min-width: 990px)').matches;
    if (!isDesktop) return;

    // Eski listener'ları kaldır
    if (state._onWheelModal) modal.removeEventListener('wheel', state._onWheelModal, { capture: true });
    if (state._onKeyDownModal) modal.removeEventListener('keydown', state._onKeyDownModal);

    let lock = false;
    let acc = 0;
    let accTimer = null;

    const isModalOpen = () => modal.classList.contains('is-open');

    const normDeltaY = (e) => {
      let dy = e.deltaY || 0;
      if (e.deltaMode === 1) dy *= 40;
      else if (e.deltaMode === 2) dy *= 800;
      return dy;
    };

    const go = (dir) => {
      const total = state.metaFiltered.length;
      if (!total) return;

      const next = Math.max(0, Math.min(state.activeIndex + dir, total - 1));
      if (next === state.activeIndex) return;

      lock = true;

      // index değişimini hazırlıyoruz (video/DOM)
      renderBufferAround(next, true);

      const h = state.slideHeight || window.innerHeight;
      feed.scrollTo({ top: next * h, behavior: 'smooth' });

      setTimeout(() => {
        lock = false;
        acc = 0;
      }, 520);
    };

    // Wheel: modal üzerinde yakala (CAPTURE), passive:false şart
    state._onWheelModal = (e) => {
      if (!isModalOpen()) return;
      if (!modal.contains(e.target)) return;

      const dy = normDeltaY(e);
      if (!dy) return;

      // video üstünde de çalışsın diye
      e.preventDefault();

      // trackpad için biriktir
      acc += dy;
      if (accTimer) clearTimeout(accTimer);
      accTimer = setTimeout(() => { acc = 0; }, 140);

      const TH = 70; //  mouse için ideal eşik
      if (Math.abs(acc) < TH) return;
      if (lock) return;

      go(acc > 0 ? +1 : -1);
    };

    modal.addEventListener('wheel', state._onWheelModal, { passive: false, capture: true });

    // Arrow/Page keys: modal odaklıyken garanti çalışır
    state._onKeyDownModal = (e) => {
      if (!isModalOpen()) return;
      if (lock) return;

      const tag = (document.activeElement?.tagName || '').toLowerCase();
      if (tag === 'input' || tag === 'textarea' || tag === 'select') return;

      if (e.key === 'ArrowDown' || e.key === 'PageDown') {
        e.preventDefault();
        go(+1);
      } else if (e.key === 'ArrowUp' || e.key === 'PageUp') {
        e.preventDefault();
        go(-1);
      }
    };

    modal.addEventListener('keydown', state._onKeyDownModal);
    state._desktopLockRef = () => lock; // scroll driver için
  }

  function setupDesktopDragControls() {
  const feed  = state.feedEl;
  const modal = document.getElementById('lrModal');
  if (!feed || !modal) return;

  const isDesktop = window.matchMedia('(min-width: 990px)').matches;
  if (!isDesktop) return;

  // eski varsa kaldır
  if (state._onPtrDown) modal.removeEventListener('pointerdown', state._onPtrDown, true);
  if (state._onPtrMove) modal.removeEventListener('pointermove', state._onPtrMove, true);
  if (state._onPtrUp)   modal.removeEventListener('pointerup', state._onPtrUp, true);

  let dragging = false;
  let startY = 0;
  let accY = 0;

  const TH = 60; // sürükleme eşiği (px)

  const go = (dir) => {
    const total = state.metaFiltered.length;
    if (!total) return;

    const next = Math.max(0, Math.min(state.activeIndex + dir, total - 1));
    if (next === state.activeIndex) return;

    // desktop snap lock var mı?
    const locked = state._desktopLockRef && state._desktopLockRef();
    if (locked) return;

    // index değişimini hazırla
    renderBufferAround(next, true);

    const h = state.slideHeight || window.innerHeight;
    feed.scrollTo({ top: next * h, behavior: 'smooth' });
  };

  state._onPtrDown = (e) => {
    // sadece modal açıkken
    if (!modal.classList.contains('is-open')) return;

    // buton/inputs üzerinde sürükleme tetiklenmesin
    const ignore = e.target.closest('button, a, input, textarea, select, .lr-sheet, .lr-sheet-panel');
    if (ignore) return;

    dragging = true;
    startY = e.clientY;
    accY = 0;

    try { modal.setPointerCapture(e.pointerId); } catch {}
    e.preventDefault();
  };

  state._onPtrMove = (e) => {
    if (!dragging) return;

    const dy = e.clientY - startY;
    startY = e.clientY;
    accY += dy;

    // aşağı sürükle => bir sonraki (dir +1)
    if (accY <= -TH) {
      accY = 0;
      go(+1);
    }
    // yukarı sürükle => bir önceki (dir -1)
    else if (accY >= TH) {
      accY = 0;
      go(-1);
    }

    e.preventDefault();
  };

  state._onPtrUp = (e) => {
    dragging = false;
    accY = 0;
    try { modal.releasePointerCapture(e.pointerId); } catch {}
  };

  modal.addEventListener('pointerdown', state._onPtrDown, { passive: false, capture: true });
  modal.addEventListener('pointermove', state._onPtrMove, { passive: false, capture: true });
  modal.addEventListener('pointerup',   state._onPtrUp,   { passive: true,  capture: true });
}


  function applyFilterAndRender(scrollToTop) {
    state.metaFiltered = getFilteredMeta();
    state.activeIndex = 0;

    // slide height: 100vh mantığı
    state.slideHeight = window.innerHeight;

    clearFeedHard();
    renderBufferAround(0, false);

    if (scrollToTop && state.feedEl) {
      state.feedEl.scrollTop = 0;
    }
  }

  /* ===== Sheet ===== */
  function openSheet(meta) {
    $('#lrSheetTitle').textContent = 'Numara Seç';
    $('#lrSheetSub').textContent = `${meta.title || ''} • ${meta.price || ''}`;

    const variants = safeJson(meta.variantsRaw || '[]', []);
    const sizes = $('#lrSizes');
    sizes.innerHTML = '';

    variants.forEach(v => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'lr-size';

      const t = (v.title || '').toString().trim();
      const parts = t.split('/').map(x => x.trim());
      btn.textContent = parts.length ? parts[parts.length - 1] : t;

      if (!v.available) btn.classList.add('is-disabled');

      btn.addEventListener('click', async () => {
        if (!v.available) return;
        try {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ id: v.id, quantity: 1 })
          }).then(r => { if (!r.ok) throw new Error('fail'); });

          toast('Sepete eklendi');
          closeSheet();
        } catch {
          toast('Sepete eklenemedi');
        }
      });

      sizes.appendChild(btn);
    });

    $('#lrSheetBackdrop').classList.add('is-open');
    $('#lrSheet').classList.add('is-open');
  }

  function closeSheet() {
    $('#lrSheetBackdrop')?.classList.remove('is-open');
    $('#lrSheet')?.classList.remove('is-open');
  }

  function syncViewportVars() {
  const vv = window.visualViewport;
  const h = vv ? vv.height : window.innerHeight;
  document.documentElement.style.setProperty('--lr-vh', `${h}px`);

  // Safari alt bar açılıp kapanınca oluşan "görünen alan" farkı
  const bottomGap = vv ? Math.max(0, window.innerHeight - vv.height - vv.offsetTop) : 0;
  document.documentElement.style.setProperty('--lr-vb', `${bottomGap}px`);
}

  /* ===== Open/Close Modal ===== */
async function openModal() {
  ensureModalUI();

  const modal = $('#lrModal');
  const feed  = $('#lrFeed');

  // modal aç
  modal.classList.add('is-open');
  preloadIcons();

  // sayfa scroll kilit
  document.documentElement.style.overflow = 'hidden';
  document.body.style.overflow = 'hidden';

  //  ok tuşları için modal odak
  modal.setAttribute('tabindex', '-1');
  modal.focus({ preventScroll: true });

  //  mobil safe area / safari bar fix
  syncViewportVars();
  window.visualViewport?.addEventListener('resize', syncViewportVars);
  window.visualViewport?.addEventListener('scroll', syncViewportVars);

  //  her açılışta meta’yı yeniden çek (sıralama değişsin istiyorsun)
  state.metaAll = [];
  state.page = 1;
  state.hasMore = true;

  await loadMoreReels();

  // temel state
  state.feedEl = feed;
  state.soundOn = false;
  state.currentVideo = null;

  // slide height: görünür alan
  state.slideHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;

  // render
  applyFilterAndRender(true);

  // scroll driver (mobil scroll -> index)
  setupScrollIndexDriver();

  // desktop wheel + arrow snap
  setupDesktopSnapControls();
  setupDesktopDragControls();

  //  resize olursa yükseklik + yerleşim güncelle
  if (state._onResize) window.removeEventListener('resize', state._onResize);
  state._onResize = () => {
    state.slideHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
    // aynı indexte kal, sadece spacer/scroll konumunu düzelt
    renderBufferAround(state.activeIndex, true);
  };

  //  modal kapanınca ESC ile kapatma (istersen)
  if (state._onEsc) modal.removeEventListener('keydown', state._onEsc);
  state._onEsc = (e) => {
    if (e.key === 'Escape') closeModal();
  };
  modal.addEventListener('keydown', state._onEsc);
}

function closeModal() {
  const modal = $('#lrModal');

  // --- resize cleanup ---
  if (state._onResize) window.removeEventListener('resize', state._onResize);
  state._onResize = null;

  // --- visualViewport cleanup ---
  window.visualViewport?.removeEventListener('resize', syncViewportVars);
  window.visualViewport?.removeEventListener('scroll', syncViewportVars);

  // --- scroll listener cleanup (feed üstündeki) ---
  if (state.feedEl && state._onScroll) {
    state.feedEl.removeEventListener('scroll', state._onScroll);
  }
  state._onScroll = null;

  // --- desktop snap cleanup (ARTIK modal üzerinde) ---
  if (modal && state._onWheelModal) {
    modal.removeEventListener('wheel', state._onWheelModal, { capture: true });
  }
  state._onWheelModal = null;

  // drag cleanup
  if (modal && state._onPtrDown) modal.removeEventListener('pointerdown', state._onPtrDown, true);
  if (modal && state._onPtrMove) modal.removeEventListener('pointermove', state._onPtrMove, true);
  if (modal && state._onPtrUp)   modal.removeEventListener('pointerup',   state._onPtrUp, true);
  state._onPtrDown = state._onPtrMove = state._onPtrUp = null;


  if (modal && state._onKeyDownModal) {
    modal.removeEventListener('keydown', state._onKeyDownModal);
  }
  state._onKeyDownModal = null;

  // ESC listener
  if (modal && state._onEsc) {
    modal.removeEventListener('keydown', state._onEsc);
  }
  state._onEsc = null;

  state._desktopLockRef = null;

  // --- videoları ve buffer'ı temizle ---
  clearFeedHard();
  state.currentVideo = null;

  // modal kapat
  modal?.classList.remove('is-open');

  // sayfa scroll geri aç
  document.documentElement.style.overflow = '';
  document.body.style.overflow = '';

  // sheet kapat
  closeSheet();

  // meta/state reset
  state.metaAll = [];
  state.metaFiltered = [];
  state.activeIndex = 0;
  state.soundOn = false;
  try { document.activeElement && document.activeElement.blur(); } catch {}
  setTimeout(() => {
    try { document.activeElement && document.activeElement.blur(); } catch {}
    try { document.body.focus(); } catch {}
  }, 0);

  // Tema scroll/menu lock class'larıyla çakışma ihtimali
  document.documentElement.classList.remove('overflow-hidden');
  document.body.classList.remove('overflow-hidden', 'drawer-open', 'menu-open', 'm-menu-open');

  try { document.activeElement && document.activeElement.blur(); } catch {}

  // iOS reflow/touch reset
  requestAnimationFrame(() => {
    try { window.scrollTo(window.scrollX, window.scrollY); } catch {}
  });

  // Modal elemanlarını DOM'dan tamamen kaldır
  try { document.getElementById('lrModal')?.remove(); } catch {}
  try { document.getElementById('lrSheet')?.remove(); } catch {}
  try { document.getElementById('lrSheetBackdrop')?.remove(); } catch {}
  try { document.getElementById('lrToast')?.remove(); } catch {}

  // State referanslarını da sıfırla
  state.feedEl = null;
  state.topSpacer = null;
  state.bottomSpacer = null;
  state.slideCache.clear();
  state.currentVideo = null;

    try {
    // 1) momentum scroll state reset
    const feed = state.feedEl || document.getElementById('lrFeed');
    if (feed) {
      // -webkit-overflow-scrolling reset
      feed.style.webkitOverflowScrolling = 'auto';
      // reflow
      void feed.offsetHeight;
      feed.style.webkitOverflowScrolling = 'touch';
    }

    // 2) header reflow (fixed header tap bug)
    const header = document.querySelector('.m-header, header, .header');
    if (header) {
      header.style.webkitTransform = 'translateZ(0)';
      void header.offsetHeight; // reflow
      header.style.webkitTransform = '';
    }

    // 3) click state reset
    document.body.style.pointerEvents = 'none';
    requestAnimationFrame(() => { document.body.style.pointerEvents = ''; });

  } catch {}
}



  document.addEventListener('DOMContentLoaded', () => {
    ensureModalUI();
    ensureButton();
    

    document.addEventListener('click', (e) => {
      const t = e.target.closest('[data-limoya-reels-open]');
      if (!t) return;
      e.preventDefault();
      openModal();
    });
  });

})();
